// removed by extract-text-webpack-plugin
module.exports = {"container":"_38mu7FmnweSUleDeEl6F0M","icon":"_1gW385rEjegAWHUFcqa5Wm","title":"hpCkplp92mnX4Hv5ntGhJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/UpdateViewers/styles.css
// module id = 2879
// module chunks = 0